export default (function (href) {
    var link = document.createElement('a');
    link.target = '_blank';
    link.href = href;
    link.click();
});
